import { IoCheckboxOutline } from "react-icons/io5";
import { IoCheckbox } from "react-icons/io5";
import { Button } from "reactstrap";
const CheckedInput = ({ value, setValue, className, style, iconSize }) => {
  return (
    <Button
    style={{height:iconSize,width:iconSize}}
      onClick={() => setValue(!value)}
      className={`p-0  bg-transparent border-none check-input ${
        value === true ? "checked" : "text-black"
      } ${className}`}
   
    >
      {value === true ? (
        <IoCheckbox size={iconSize} />
      ) : (
        <IoCheckboxOutline size={iconSize} />
      )}
    </Button>
  );
};

export default CheckedInput;
